import { render, staticRenderFns } from "./o-button.vue?vue&type=template&id=60f4456c"
import script from "./o-button.js?vue&type=script&lang=js&external"
export * from "./o-button.js?vue&type=script&lang=js&external"
import style0 from "./o-button.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports